import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=47169f03&scoped=true&"
import script from "./Examination.vue?vue&type=script&lang=js&"
export * from "./Examination.vue?vue&type=script&lang=js&"
import style0 from "./Examination.vue?vue&type=style&index=0&id=47169f03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47169f03",
  null
  
)

export default component.exports